export enum TrackingEvent {
  MobileModalLoaded = `mobile-immersive-modal-opened`,
  ModalLoaded = `immersive-modal-opened`,
  CloseModal = `immersive-modal-closed`,
  MobileCloseModal = `mobile-immersive-modal-closed`,
  StepClick = `sidebar-button-click`,
  SkipForNow = `sidebar-skip-for-now-click`,
  SummaryTableEditClick = `summary-table-edit-click`,

  WelcomeResourceClick = `welcome-resource-click`,
  WelcomeStartSetupClick = `welcome-start-setup-click`,
  WelcomeConnectDataClick = `welcome-connect-data-click`,
  WelcomePersonalizeSetupClick = `welcome-personalize-setup-click`,

  SkipStep = `step1-skip-step-click`,
  EventsLearnMoreClick = `step1-events-learn-more-click`,
  InviteDevelopers = `step1-invite-developers`,
  LearnMoreClick = `step1-default-props-learn-more-click`,
  ViewDemoClick = `step1-view-demo-click`,
  SubStepCompleted = `step1-substep-answered`,
  SubStepSkipped = `step1-substep-skipped`,

  EditEvent = `step2-edit-events-click`,
  InviteTeammate = `step2-invite-teammate`,

  TemplateClick = `step3-template-click`,
  TemplateTabClick = `step3-template-tab-click`,
  Finish = `step3-finish-close-click`,

  // Phase 2
  Back = `step2-back-button-click`,
  ViewUsersClick = `view-users-button-click`,
  ViewEventsClick = `view-events-button-click`,
}

export enum TrackingProperty {
  Source = `source`,
  StepName = `step-name`,
  CurrentStep = `current-step`,
  Name = `name`,
  Count = `count`,
  Template = `template`,
  SubStepName = `sub-step`,
  Phase2 = `immersive-onboarding-phase2`,
  WelcomeVariant = `welcome-variant`,
}

export const track = (event: TrackingEvent, property?: {[key in TrackingProperty]?: string | number | boolean}) => {
  mixpanel.track(`[Immersive Onboarding] ${event}`, property);
};

// For compatibility with the old setup page
export enum SetUpTrackingEvent {
  LinkClicked = `Link Clicked`,
  TokenCopied = `Token Copied`,
  IntegratedWithinSession = `Project Integrated within Setup Session`,
}

export const trackSetUp = (event: SetUpTrackingEvent, props?: {[key: string]: string | number | boolean}) => {
  mixpanel.track(`[Set Up] ${event}`, {
    ...props,
    source: `immersive_onboarding`,
  });
};
